const routeShape = {
    viewDepartTime: '',
    viewDepartDate: '',
    flightTime: '',
    from: '',
    fromAirport: '',
    fromAirportDetail: '',
    fromCodeAirport: '',
    fromLatitude: '0',
    fromLongitude: '0',
    fromState: '',
    order: 0,
    passengerNumber: 2,
    passengerRange: false,
    passengerRange_Max: 2,
    passengerRange_Min: 1,
    passengersManifest: 0,
    payload: 25,
    to: '',
    toAirport: '',
    toAirportDetail: '',
    toCodeAirport: '',
    toLatitude:'0',
    toLongitude:'0',
    toState: ''
};
const charterRequestShape = {
    aspNetId: '',
    allowCharterShare: false,
    bidable: false,
    biddingTimeSpanHours: 24,
    biddingToCloseInTicks: 2592000000000,
    catering: 'Full',
    changeCharterRequestId: '00000000-0000-0000-0000-000000000000',
    changeInCost: 0,
    changeStatus: '',
    changeToCost: 0,
    changeToCostWithMargin: 0,
    charterSubType: "Passenger Transfer",
    charterType: "Passenger",
    clientCompanyAddress: '',
    clientCompanyName: '',
    clientCompanyPhone: '',
    clientId: "1bda4e89-c35b-4f3d-a7d3-2d9629fd10f3",
    clientName: '',
    clientPhone: '',
    clientType: '',
    closedAt: null,
    createdAt: null,
    createdClosedAt: '',
    dangerousGoods: false,
    dangerousGoodsIds: '3,5',
    dangerousGoodsList: '',
    extensible: false,
    firstFlightAt: '',
    hidePrice: false,
    id: '',
    isShare: false,
    jobReference: '',
    leadBidSummary: '',
    maxPassengerNumber: 0,
    minPassengerNumber: 0,
    operatorNotes: '',
    originalCostWithMargin: 0,
    pendingChanges: false,
    preferredAircraft: '',
    purchaseOrderNumber: '',
    reasonForCharter: '',
    shared: 'True',
    specialRequests: '',
    stateCss: '',
    status: '',
    supplierCompanyName: '',
    supplierId: '',
    supplierPhone: '',
    totalRoutes: 0,
    urgent: false,
    verifiedAt: '',
    viewable: false,
    weightMax: 0,
    weightMin: 0,
    withdrawReason: '',
    airRoutes: [{ ...routeShape }],
};
const newCharterRequestShape = {
    aspNetId: '',
    allowCharterShare: false,
    bidable: false,
    biddingTimeSpanHours: 24,
    biddingToCloseInTicks: 2592000000000,
    catering: 'Full',
    changeCharterRequestId: null,
    changeInCost: 0,
    changeStatus: '',
    changeToCost: 0,
    changeToCostWithMargin: 0,
    charterSubType: "",
    charterType: "",
    clientCompanyAddress: '',
    clientCompanyName: '',
    clientCompanyPhone: '',
    clientId: '',
    clientName: '',
    clientPhone: '',
    clientType: '',
    closedAt: '',
    dangerousGoods: false,
    dangerousGoodsIds: '',
    extensible: false,
    hidePrice: false,
    isShare: false,
    jobReference: '',
    operatorNotes: '',
    originalCostWithMargin: 0,
    pendingChanges: false,
    preferredAircraft: '',
    purchaseOrderNumber: '',
    reasonForCharter: '',
    shared: false,
    specialRequests: '',
    stateCss: '',
    status: '',
    supplierCompanyName: '',
   
    supplierPhone: '',
    totalRoutes: 0,
    urgent: false,
    
    viewable: false,
    weightMax: 0,
    weightMin: 0,
    withdrawReason: '',
    routes: [routeShape],
    bidHistories:[],
};
const newShareCharter = {
    passengerName: '',
    contactNumber: '',
    emailAddress: '',
    passengerWeight: 85,
    freightWeight: 15,
    cargoWeight: 0,
};
export { newCharterRequestShape, charterRequestShape, routeShape, newShareCharter };